import React from "react"
import "./NewElementModal.css"
import { getTranslation } from "../../assets/creator/translations"

const NewElementModal = props => {
	if (!props.show) {
		return null;
	}

	return (
		<div className='newelement-modal'>
			<div className='newelement-modal__cloud newelement-modal__cloudFirst'>
				<button className='closeBtn' onClick={props.handleClose}>
					<svg
						width='20'
						height='20'
						viewBox='0 0 24 24'
						xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z'
							fillRule='evenodd'
						/>
					</svg>
				</button>
				<div className='newelement-modal__cloud-textSection'>
					<p className='titleInstruction'>
						{getTranslation("NewElement_HeaderText")}
					</p>
					<p className='textInstruction1 textInstruction1__cloudFirst'>
						{getTranslation("NewElement_LabelText")} {" "} {getTranslation("NewElement_" + props.type)}
					</p>
					<div className='textInstruction2 textInstruction2__cloudFirst'>
						<img alt="" src="./img/diamond.png"/>
						<span>{getTranslation("NewElement_description_" + props.type)}</span>    
					</div>
				</div>
			</div>
		</div>
	)
}

export default NewElementModal;